import React, { useEffect, useState } from 'react'
import ProductStep1 from './product_step_1'
import ProductStep2 from './productStep2'
import EditProduct from './edit-product'
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { hideLoader, showLoader } from '../loader';
import { apiUrl } from '../../utils/url';
import { toast } from 'react-toastify';
import { createFormdataValues } from '../../utils/createFormdataValues';
import CampaignTemplateStep from './campaign-template-step';
import ProductTypeModal from './product_type_modal';

function ProductMain({from,onClose,showCreateProduct,setShowCreateProduct,callAllBrands}) {
  const location = useLocation();
  const history = useHistory();
  const { slug, basePath } = useSelector((state) => state?.slugReducer);
  const [showProductStep1, setShowProductStep1] = useState(false)
  const [showProductStep2, setShowProductStep2] = useState(false)
  const [title, setTitle] = useState("");
  const [error, setError] = useState({});
  const [errorMessage, setErrorMessage] = useState('');
  const [product_slug, setProductSlug] = useState("");
  const brandings = useSelector(state => state?.allBrandingReducer);
  const defaultBranding = brandings.find(branding => branding.is_default === true || branding.is_default === 1) || brandings[0];
  const [values, setValues] = useState({title:null, branding_id:defaultBranding?.id,product_slug:null});
    async function handleSave() {
      showLoader();
      setError({});
      // const obj = {
      //   title,
      //   short_description,
      //   product_slug,
      //   product_theme,
      //   accent_theme,
      //   logo,
      //   company_name,
      //   button_url,
      // };
  
      const api = apiUrl + "/ProductFlow/createProduct";
      const formdata = createFormdataValues(values);
         
      formdata.append("project", slug);
      // cover_image.map((val, key) => {
      //   // console.log("productTemplateMarkup", new File([val.img], "image.png"));
      //   if (val?.img) {
      //     formdata.append("cover_image[]", new File([val.img], "image.png"));
      //   }
      // });
      const myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        `Bearer ${localStorage?.getItem("token")}`
      );
      const setOptions = {
        method: "POST",
        body: formdata,
        headers: myHeaders,
      };
      fetch(api, setOptions)
        .then(async (res) => {
          const response = await res?.json();
          if (response?.status_code == 200) {
            setShowProductStep2(false);
            setShowProductStep1(false);
            // if(from == 'productType'){
            //   closeProductType();
            // }
            // history.push({
            //   pathname: basePath + "/editCampaign",
            //   state:{
            //     edit:{ is: true, id: response?.id },
            //     product_id:response?.data?.product_id,
            //     fron:null
            //   }
            // });
            history.push({
                pathname: basePath + "/campaign/"+ response?.data?.product_id + "/leads", state: {
                    product_id: response?.data?.product_id,
                    edit: { is: true, id: response?.data?.product_id }
                }
            });
            hideLoader();
            toast.success(`Campaign Created Successfully `)
          } else {
            setError(Object.values(response?.errors));
            if (Object.keys(response?.errors).length > 0)
              $(".modal-body").scrollTop(0);
            hideLoader();
          }
        })
        .catch(() => {
          hideLoader();
        });
    }
    const nextStep = (id) => {
      if(id == 'default'){
        setValues({...values,builder_id:'default'})
      }else {
        setValues({...values,builder_id:id})
      }
      setShowCreateProduct('legacy');
      // setShowProductStep1(false);
      // setShowProductStep2(true);
    };
  return (
    <>
    {from !== 'template' ?
        <EditProduct/> :
        <>
            {showCreateProduct == true && <ProductTypeModal callAllBrands={callAllBrands} showCreateProduct={showCreateProduct} setShowCreateProduct={setShowCreateProduct} isOpen={showCreateProduct} onClose={onClose}/>}
            {showCreateProduct == 'pageBuilder' && <CampaignTemplateStep showProductStep1={showCreateProduct == 'pageBuilder'} setShowProductStep1={setShowProductStep1} nextStep={nextStep}  onClose={onClose} title={title} setTitle={setTitle }error={error} setError={setError} errorMessage={errorMessage} setErrorMessage={setErrorMessage } product_slug={product_slug} setProductSlug={setProductSlug} values={values} setValues={setValues} defaultBranding={defaultBranding}/>}
            {(showCreateProduct == 'legacy')&& <ProductStep1 showProductStep2={showCreateProduct == 'legacy'} nextStep={handleSave}  onClose={onClose} error={error} setError={setError} errorMessage={errorMessage} setErrorMessage={setErrorMessage } product_slug={product_slug} setProductSlug={setProductSlug} values={values} setValues={setValues} defaultBranding={defaultBranding}/>}
        </>
    }
    </>
  )
}

export default ProductMain